<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="Dedication-ded"><span class="ePub-I">To Christy, for all the obvious reasons, and three secret ones</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4b315e02